import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { SvgIconProps } from "@mui/material";
import React, { useId } from "react";
import { indigoSkyGradientStops } from "./assistedIconBadgeSx";

/**
 * Sparkles icon filled with the indigo → sky gradient.
 * Each instance gets its own gradient id so multiple icons can render safely.
 */
export const AiAssistedSparklesIcon = ({ sx, ...props }: SvgIconProps) => {
  const reactId = useId().replace(/:/g, "");
  const gradientId = `indigo-sky-icon-gradient-${reactId}`;

  return (
    <>
      <svg width={0} height={0} aria-hidden style={{ position: "absolute" }}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={indigoSkyGradientStops.indigo} />
            <stop offset="55%" stopColor={indigoSkyGradientStops.blue} />
            <stop offset="100%" stopColor={indigoSkyGradientStops.sky} />
          </linearGradient>
        </defs>
      </svg>
      <AutoAwesomeIcon
        {...props}
        sx={[
          { fill: `url(#${gradientId})` },
          ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        ]}
      />
    </>
  );
};
